import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';
import { MainLayoutComponent } from 'app/shared/components/layouts/main-layout/main-layout.component';

@Component({
  selector: 'ez-server-error',
  imports: [MainLayoutComponent, RouterLink],
  templateUrl: './server-error.component.html',
  styleUrl: './server-error.component.scss',
})
export class ServerErrorComponent {}
